import { mapStyles } from './map-style';

interface GoogleMapOptions {
    container: Element,
    latitude: number,
    longitude: number
}

export class GoogleMap {
    public map!: google.maps.Map;
    private container!: Element;
    private center!: google.maps.LatLng;

    constructor(mapOptions: GoogleMapOptions) {
        if(!mapOptions.container || !mapOptions.latitude || !mapOptions.longitude) return;

        // Set our properties
        this.container = mapOptions.container;
        this.center    = new google.maps.LatLng(mapOptions.latitude, mapOptions.longitude);
        this.map       = this.render();
    }


    /**
     * Renders the Google Map
     * 
     * @private
     * @memberof GoogleMap
     */
    private render(marker = true) {

        // Render the map
        const map = new google.maps.Map(this.container, {
            center: this.center,
            zoom: 14,
            styles: mapStyles,
            streetViewControl: false,
            fullscreenControl: false,
            mapTypeControl: false,
            zoomControlOptions: {
                position: google.maps.ControlPosition.LEFT_BOTTOM
            },
        });

        // Render the marker
        if(marker) {
            const markerObject = this.getNewMapMarker();
            markerObject.setMap(map);
        }

        return map;
    }


    /**
     * Returns a new marker with our custom icon
     * 
     * @private
     * @memberof GoogleMap
     * @returns google.maps.Marker
     */
    private getNewMapMarker(): google.maps.Marker {

        return new google.maps.Marker({
            position: this.center,
            map: this.map,
            icon: {
                path: 'M16 0c-5.523 0-10 4.477-10 10 0 10 10 22 10 22s10-12 10-22c0-5.523-4.477-10-10-10zM16 16.125c-3.383 0-6.125-2.742-6.125-6.125s2.742-6.125 6.125-6.125 6.125 2.742 6.125 6.125-2.742 6.125-6.125 6.125zM12.125 10c0-2.14 1.735-3.875 3.875-3.875s3.875 1.735 3.875 3.875c0 2.14-1.735 3.875-3.875 3.875s-3.875-1.735-3.875-3.875z',
                fillColor: '#472550',
                fillOpacity: 1,
                strokeWeight: 0,
                scale: 1,
                anchor: new google.maps.Point(16,32)
            }
        })
    }
}
